if (process.env.REACT_APP_USE_FIXTURES === 'true') {
  module.exports = require('./Api.mock');
} else {
  module.exports = require('./Api.live');
}



// WEBPACK FOOTER //
// ./src/services/Api/index.js